import { render, staticRenderFns } from "./ClaimJourney.vue?vue&type=template&id=13ce8a83&scoped=true&lang=pug&"
import script from "./ClaimJourney.vue?vue&type=script&lang=js&"
export * from "./ClaimJourney.vue?vue&type=script&lang=js&"
import style0 from "./ClaimJourney.vue?vue&type=style&index=0&id=13ce8a83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce8a83",
  null
  
)

export default component.exports